import * as React from "react";
import styled from "@mui/material/styles/styled";
import { usePatientSummary } from "fe-common/patientSummary/useFetchPatientSummary";
import { ThreeDotsLoader } from "fe-web-components/loader/threeDotsLoader";
import { PatientFirstSummaryView } from "fe-web-components/patientCard/patientFirstSummaryView";
import { KAHUN_PLATFORM } from "user-management/src/components/loginForm";
//region [[ Styles ]]

const PatientFirstSummaryContentView = styled("div")(({ theme }) => ({}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientFirstSummaryContentProps {
  sharedId: string;
  clinicId?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientFirstSummaryContent = ({
  sharedId,
  clinicId,
  ...props
}: PatientFirstSummaryContentProps) => {
  const { summary: patientSummary, loading } = usePatientSummary(
    sharedId,
    clinicId,
  );

  if (!patientSummary) return null;

  return (
    <PatientFirstSummaryContentView>
      {loading && <ThreeDotsLoader />}
      {!loading && (
        <PatientFirstSummaryView
          patientSummary={patientSummary}
          showPatientInformation={true}
          supportedSections={[]}
          onNotify={() => console.log("copied")}
          clinicName={""}
          clinicId={""}
          platform={KAHUN_PLATFORM.AGENT}
        />
      )}
    </PatientFirstSummaryContentView>
  );
};
